import Heading from '@components/web/heading/Heading.tsx';
import FeatureRow from '@/pages/home/components/features/FeatureRow.tsx';
import {
  featureListOneItems,
  featureListThree,
  featureListTwoItems
} from '@/pages/home/components/features/feature.data.tsx';
import FeatureColumns from '@/pages/home/components/features/FeatureColumns.tsx';

const Features = () => {
  return (
    <div id="modules" className="scroller">
      <Heading title="Nog een paar redenen waarom je zal genieten van Solvere" />
      <div className="grid grid-rows-1 gap-20 py-20">
        <FeatureRow data={featureListOneItems} />
        <FeatureRow data={featureListTwoItems} />
        <FeatureColumns data={featureListThree} />
      </div>
    </div>
  );
};

export default Features;
